"use strict";

exports.__esModule = true;
exports.ImageLoadStates = exports.AvatarSize = void 0;
let AvatarSize = /*#__PURE__*/function (AvatarSize) {
  AvatarSize["xLarge"] = "xLarge";
  AvatarSize["large"] = "large";
  AvatarSize["medium"] = "medium";
  AvatarSize["small"] = "small";
  AvatarSize["xSmall"] = "xSmall";
  AvatarSize["xxSmall"] = "xxSmall";
  return AvatarSize;
}({});
exports.AvatarSize = AvatarSize;
let ImageLoadStates = /*#__PURE__*/function (ImageLoadStates) {
  ImageLoadStates[ImageLoadStates["READY"] = 0] = "READY";
  ImageLoadStates[ImageLoadStates["LOADING"] = 1] = "LOADING";
  ImageLoadStates[ImageLoadStates["FAILURE"] = 2] = "FAILURE";
  return ImageLoadStates;
}({});
/** ******** Base component **********/
/** *************************/
exports.ImageLoadStates = ImageLoadStates;
//# sourceMappingURL=types.js.map